'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ../~/react-dom/index.js
// module id = 453
// module chunks = 2